import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TraceabilityService {

  private baseUrl = '/catalog/traceability';

  constructor(private http: HttpClient) {
  }

  retrieveLogs(mustFilter: any[], filter: any[], pageNumber: number, pageSize: number): Observable<any> {
    return this.http.post<any>(this.baseUrl, {
      query: {
        bool: {
          must: mustFilter,
          must_not: [],
          should: [],
          filter
        }
      },
      from: pageNumber,
      size: pageSize,
      sort: [{ timestamp: { order: 'desc' } }],
      aggs: {}
    });
  }

  buildFullMatchCondition(field: string, value: string) {
    return {
      bool: {
        should: [{ match_phrase: { [field]: value } }]
      }
    };
  }

  buildPartialMatchCondition(field: string, value: string) {
    return {
      bool: {
        minimum_should_match: 1,
        should: [{ match_phrase: { [field]: value } }]
      }
    };
  }

  buildSearchTermCondition(searchTerm: string) {
    return {
      multi_match: {
        type: 'best_fields',
        query: searchTerm,
        lenient: true
      }
    };
  }

  buildDateCondition(minutesAgo: number) {
    const minutesAgoInMilliseconds = minutesAgo * 60000;
    const now = new Date();
    const past = new Date(now.getTime() - minutesAgoInMilliseconds);
    return {
      range: {
        '@timestamp': {
          format: 'strict_date_optional_time',
          gte: past,
          lte: now
        }
      }
    };
  }

}
